import { Component, OnInit } from '@angular/core';
import TournamentBase from '../../tournament-base';
import { TournamentCategorySubscription } from '../../tournament.interface';
import { ActivatedRoute } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { DialogConfirmActionComponent } from '@theme/components';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/modules/user/user.service';
import { CancelSubscriptionTokenValidationComponent } from '../cancel-subscription-token-validation/cancel-subscription-token-validation.component';

@Component({
    selector: 'app-cancel-subscription',
    templateUrl: './cancel-subscription.component.html',
    styleUrls: ['./cancel-subscription.component.scss'],
})
export class CancelSubscriptionComponent extends TournamentBase implements OnInit {
    departmentType: string = this.getDepartmentType();
    tournamentId: string = this.route.snapshot.paramMap.get('tournamentId');
    loading: boolean = false;
    categories: TournamentCategorySubscription[];
    selectedCategory: TournamentCategorySubscription;

    constructor(
        protected route: ActivatedRoute,
        private dialog: NbDialogService,
        private translate: TranslateService,
        private toastr: NbToastrService,
        private user: UserService
    ) {
        super();
    }

    ngOnInit(): void {
        this.loading = true;
        this.tournamentService.getSubscriptionsToCancel(this.tournamentId, this.departmentType).subscribe(
            (response) => {
                this.categories = response.registers;
            },
            () => {
                this.toastr.danger(
                    this.translate.instant('ALERT.ERROR.DESCRIPTION'),
                    this.translate.instant('ALERT.ERROR.TITLE')
                );
                this.location.back();
            },
            () => {
                this.loading = false;
            }
        );
    }

    async onCancelEnrollment(event) {
        event.stopPropagation();
        event.preventDefault();
        if (!this.tournamentId || !this.selectedCategory.id_categoria || !this.selectedCategory.id_ficha) {
            this.toastr.danger(
                this.translate.instant('ALERT.ERROR.DESCRIPTION'),
                this.translate.instant('ALERT.ERROR.TITLE')
            );
            return;
        }
        const dialog = this.dialog.open(DialogConfirmActionComponent, {
            context: {
                message: this.translate.instant('GENERAL.CANCEL-SUBSCRIPTION'),
                confirmText: `${this.translate.instant('GENERAL.YES')}, ${this.translate
                    .instant('BUTTONS.CANCEL-SUBSCRIPTION')
                    .toLowerCase()}`,
            },
        });
        const promptConfirmed = await dialog.onClose.toPromise();
        if (!promptConfirmed) return;

        const user = this.user.currentUser.getValue();

        const tokenDialog = this.dialog.open(CancelSubscriptionTokenValidationComponent, {
            context: {
                player: user.id_site,
                tournamentId: this.tournamentId,
                categoryId: this.selectedCategory.id_categoria,
            },
        });
        const tokenConfirmed = await tokenDialog.onClose.toPromise();
        if (!tokenConfirmed) return;

        this.cancelSubscription(tokenConfirmed);
    }

    cancelSubscription(code) {
        this.loading = true;
        this.tournamentService
            .cancelEnrollment(
                this.tournamentId,
                this.selectedCategory.id_categoria,
                this.selectedCategory.id_ficha,
                code
            )
            .subscribe((response) => {
                const title = response.status_code > 0 ? 'Erro' : 'Sucesso';
                const status = response.status_code > 0 ? 'danger' : 'success';
                this.loading = false;

                this.toastr.show(response.description, title, { status });
                if (response.status_code === 0) {
                    this.location.back();
                }
            });
    }
}
